import React from "react";
import * as CHQ from "chq";
import { Link } from "react-router-dom";

import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type SuccessScheduledyNotificationProps = {
  notification: CHQ.NotificationSuccessScheduledShare;
  tabIndex?: number;
};

const SuccessScheduledyNotification: React.FC<SuccessScheduledyNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <Trans>
      Your
      {" "}
      <Link to={`/admin/story-reviews/published?id=${entity?.id}`} tabIndex={tabIndex || 0}>
        social share
      </Link>
      {" "}
      was successfully scheduled!
    </Trans>
  </NotificationBody>
);

export default SuccessScheduledyNotification;
